import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Router Wrapper
const PrivateRoute = ({ component: Child, ...props }) => {
  return (
    <Route
      {...props}
      render={routeProps => (props.authenticated ? (
        <Child
          {...routeProps}
          {...props}
        />
      ) : (
        <Redirect to="/" />
      ))}
    />
  );
};

export default PrivateRoute;
